<section>
  @if (isOpen$ | async) {
    <div>
      <ng-content></ng-content>
    </div>
  }
  <sh-action-item [item]="accordionActionItem$ | async"></sh-action-item>
</section>
